module.exports = __webpack_public_path__ + "media/images/front/timeline/about_us_2010-ac66722de7b36211de3ac17a4038d45e.webp";